export class FloorModel {
  id: any
  constructor() {
    this.id = undefined
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new FloorModel(), obj)

    newObj.projectId = obj.tower?.projectId ?? []

    return newObj
  }

  public static assigns<T>(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}
